import configurationClient from '@/axiosClients/configurationClient'
import {errorHttpMessage} from "@/utils/errorDecodeUtil"

export const saveUser = async ({commit}, formData) => {

    try {
        const {data: result} = await configurationClient.post('/profile/edit', formData)
        // HCSO-2891: `error_code` (fallo) e `image_profile` (URL nueva de la foto)
        // ya no se tiran. Antes esta desestructuración descartaba la pista real
        // que traía la respuesta.
        const { message, error, error_code, contact_changed, image_profile } = result.result

        if (!error) {
            const user = JSON.parse(sessionStorage.getItem('user'))
            if (user) {
                if (user.force_password_change) {
                    user.force_password_change = false
                }
                sessionStorage.setItem('user', JSON.stringify(user))
                commit('auth/updateUser', user, {root: true})
            }
        }

        return { message, error, error_code, contact_changed, image_profile }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {
            message: error_http_message.message,
            error_keys: error_http_message.error_keys,
            error_code: error_http_message.error_code ?? null,
            data: ex.response?.data ?? null,
            error: true
        }
    }

}

export const findUserByToken = async ({commit}, userId) => {
    try {
        const {data: result} = await configurationClient.get(`/profile`)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const deleteImage = async ({commit}, type) => {
    try {
        const {data: result} = await configurationClient.delete('/profile/' + type)
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, data: ex, error: true}
    }
}

export const getPractitionerTitles = async ({commit}) => {

    try {
        const {data: result} = await configurationClient.get('/catalog/practitioner-titles')
        const {data, message, error} = result.result
        return {data, message, error}
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex);
        return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response.data, error: true}
    }

}



